import { render, staticRenderFns } from "./quesTionList.vue?vue&type=template&id=2fd470b0&scoped=true"
import script from "./quesTionList.vue?vue&type=script&lang=js"
export * from "./quesTionList.vue?vue&type=script&lang=js"
import style0 from "./quesTionList.vue?vue&type=style&index=0&id=2fd470b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd470b0",
  null
  
)

export default component.exports